import React, { Suspense } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import ContentAreaLoader from 'components/atoms/Loaders/ContentAreaLoader';
import { AppShellContext } from 'context/AppShellContext';
import AuthService from 'services/Auth';
import routeCodes from 'common/constants/route-codes';
import { useUser } from 'redux/user/use-user';

import LayoutShell from './LayoutShell';

const AppShell = ({ children }) => {
  const { isSuperAdmin } = useUser();
  const { pathname } = useLocation();
  const hasRestaurant = Boolean(AuthService.getCurrentRestaurant());
  // Allow profile (create company/restaurant) without a selected restaurant.
  const isProfileRoute = pathname.startsWith(routeCodes.profile);

  // Normal users must select a restaurant before seeing the app shell/sidebar,
  // except when managing profile so they can create their first restaurant.
  if (!isSuperAdmin && !hasRestaurant && !isProfileRoute) {
    return (
      <Redirect
        to={`${routeCodes.chooseRestaurant}${window.location.search}`}
      />
    );
  }

  return (
    <AppShellContext.Provider value={true}>
      <LayoutShell>
        <Suspense fallback={<ContentAreaLoader />}>{children}</Suspense>
      </LayoutShell>
    </AppShellContext.Provider>
  );
};

export default AppShell;
